import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
export const SsrPropsContext = /*#__PURE__*/ createContext(undefined);
const SsrPropsContextProvider = ({ children , isSsrUserAgentCinchApp  })=>/*#__PURE__*/ _jsx(SsrPropsContext.Provider, {
        value: {
            isSsrUserAgentCinchApp
        },
        children: children
    });
const useSsrProps = ()=>{
    const context = useContext(SsrPropsContext);
    if (context === undefined) {
        throw new Error("useSsrPropsContext must be used within a SsrPropsContextProvider");
    }
    return context;
};
export { SsrPropsContextProvider, useSsrProps };
